import PolarChartBlock from './PolarChartBlock';

export default PolarChartBlock;
